import { render, staticRenderFns } from "./Restriction.vue?vue&type=template&id=4cb0e371"
import script from "./Restriction.vue?vue&type=script&lang=js"
export * from "./Restriction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports